import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class DateSheetsService extends GoogleSheetsBaseService {


  /**
   * Retrieves tasking types for a dropdown menu from a Google Sheet.
   * This function has been modernized to use the GoogleSheetsBaseService.
   * @returns An Observable of an array of objects for the dropdown.
   */
  public getTaskingTypes(): Observable<any[]> {
    const tabName = 'workflow';
    const startCell = 'I2';
    const endCell = 'I25';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of important date types from the 'importantdates' sheet.
   * @returns An observable of the date types.
   */
  getImportantDateTypes(): Observable<any> {
    const tabName = 'importantdates';
    const startCell = 'A2';
    const endCell = 'A100';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }
}